import { render, staticRenderFns } from "./BlackGoldToastHost.vue?vue&type=template&id=b7ae7c00&"
import script from "./BlackGoldToastHost.vue?vue&type=script&lang=js&"
export * from "./BlackGoldToastHost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports